import { routeGenerator } from '@app/modules/fragments/routing/FragmentsRoutes';
import { webApi } from '@mi-front/api-clients';
import { Card, CardContent } from '@mui/material';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { FragmentCardFooter } from './FragmentCardFooter';
import { FragmentCardTitle } from './FragmentCardTitle';
import { fragmentCardBaseSx, fragmentCardContentSx } from './styles';

/**
 * Shared card wrapper for fragment cards: layout and click navigation to fragment view.
 * Uses a Link so the card is a real link (Ctrl/Cmd+click opens in new tab, right-click menu works).
 * Renders optional media (e.g. poster), then CardContent wrapping content, then footer.
 */
export function FragmentCardBase({
  fragment,
  media,
  content,
}: {
  fragment: webApi.FragmentListItemDto;
  /** Optional media area (e.g. poster for video cards). */
  media?: ReactNode;
  /** Main content rendered inside CardContent. */
  content?: ReactNode;
}) {
  const to = routeGenerator.view(fragment.id);

  return (
    <Link to={to} style={{ textDecoration: 'none', color: 'inherit' }}>
      <Card sx={fragmentCardBaseSx}>
        {media}
        <CardContent sx={fragmentCardContentSx}>
          {content ?? <FragmentCardTitle title={fragment.title} />}
        </CardContent>
        <FragmentCardFooter fragment={fragment} />
      </Card>
    </Link>
  );
}
